// Environment configuration for Acceron Delnie Cloud Admin
export interface EnvironmentConfig {
  API_URL: string;
  NODE_ENV: string;
  APP_NAME: string;
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  // Use environment variables from .env files
  const apiUrl = (process as any).env.REACT_APP_API_URL;
  const appName = (process as any).env.REACT_APP_APP_NAME;
  // React scripts always sets NODE_ENV=development, so we prioritize REACT_APP_ENV
  // If no REACT_APP_ENV is set, default to production (not development)
  const env = (process as any).env.REACT_APP_ENV || 'production';
  
  console.log('🌍 Environment Variables:', {
    REACT_APP_ENV: (process as any).env.REACT_APP_ENV,
    NODE_ENV: (process as any).env.NODE_ENV,
    REACT_APP_API_URL: apiUrl,
    REACT_APP_APP_NAME: appName,
    detected_env: env
  });
  
  // If .env variables are available, use them
  if (apiUrl && appName) {
    console.log('📝 Using .env variables');
    return {
      API_URL: apiUrl,
      NODE_ENV: env,
      APP_NAME: appName
    };
  }
  
  // Fallback to hardcoded values
  console.log('🔧 Using hardcoded config for environment:', env);
  switch (env) {
    case 'development':
      console.log('🛠️ Loading DEVELOPMENT config');
      return {
        API_URL: 'http://localhost:3063/api/',
        NODE_ENV: 'development',
        APP_NAME: 'Acceron Admin (Development)'
      };
    
    case 'production':
    default:
      console.log('🚀 Loading PRODUCTION config');
      return {
        API_URL: 'https://api-acceron.delnie.cloud/api/',
        NODE_ENV: 'production',
        APP_NAME: 'Acceron Admin (Production)'
      };
  }
};

export const config = getEnvironmentConfig();

// Log current configuration with timestamp to avoid caching
console.log('🔧 API Configuration [' + new Date().toISOString() + ']:', {
  API_URL: config.API_URL,
  NODE_ENV: config.NODE_ENV,
  APP_NAME: config.APP_NAME,
  timestamp: Date.now()
});

export default config;
